import types from '../mutation-types';
import MotorReservaConfigAPI from '../../api/motorReservaConfig';

export const state = {
  record: {},
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
};

export const getters = {
  getConfig(_state) {
    return _state.record;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async function getConfig({ commit }) {
    commit(types.SET_MOTOR_RESERVA_CONFIG_UI_FLAG, { isFetching: true });
    try {
      const response = await MotorReservaConfigAPI.get();
      commit(types.SET_MOTOR_RESERVA_CONFIG, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_MOTOR_RESERVA_CONFIG_UI_FLAG, { isFetching: false });
    }
  },

  update: async function updateConfig({ commit }, data) {
    commit(types.SET_MOTOR_RESERVA_CONFIG_UI_FLAG, { isUpdating: true });
    try {
      const response = await MotorReservaConfigAPI.update(data);
      commit(types.SET_MOTOR_RESERVA_CONFIG, response.data);
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_MOTOR_RESERVA_CONFIG_UI_FLAG, { isUpdating: false });
    }
  },
};

export const mutations = {
  [types.SET_MOTOR_RESERVA_CONFIG_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.SET_MOTOR_RESERVA_CONFIG](_state, data) {
    _state.record = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
